import router from './router'
import { getToken } from './utils'
import store from './store'

const whiteList = [
  '/auth/login'
] // no redirect whitelist

router.beforeEach(async (to, from, next) => {
  const hasToken = getToken()

  if (hasToken) {
    // if (this.user !== {}) await this.$store.dispatch('user/getUserInfo')
    if (to.path === '/auth/login' || to.path.indexOf('/pub/') >= 0) {
      // if is logged in, redirect to the home page
      next({ path: '/' })
    } else {
      next()
      const hasGetUserInfo = Object.keys(store.getters.user).length > 0

      if (hasGetUserInfo) {
        next()
      } else {
        try {
          // get user info
          await store.dispatch('user/getUserInfo')
          next()
        } catch (error) {
          // remove token and go to login page to re-login
          await store.dispatch('user/resetToken')
          alert(error || 'Hubo un Error')
          next(`/auth/login?redirect=${to.path}`)
        }
      }
    }
  } else {
    /* has no token */
    if (whiteList.indexOf(to.path) !== -1 || to.path.indexOf('/pub/') >= 0 || to.path.indexOf('/shared/') >= 0) {
      // in the free login whitelist, go directly
      next()
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      next(`/auth/login?redirect=${to.path}`)
    }
  }
})

router.afterEach(() => {
  // finish progress bar
})
